import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { User } from 'src/app/beans/login/user/user.bean';
import { ServiceCategory } from 'src/app/beans/service/service.category.bean';
import { ServiceDetail } from 'src/app/beans/service/service.detail.bean';
import { ServiceMin } from 'src/app/beans/service/service.min.bean';
import { Site } from 'src/app/beans/site/site.bean';
import { OrganizationSelect } from 'src/app/components/select/organization/organization-select/organization.select';
import { SiteSelect } from 'src/app/components/select/site/site-select/site.select';
import { CustomButton, CustomColumn, CustomTableComponent } from 'src/app/components/table/custom-table/custom-table.component';
import { GenericDialog } from 'src/app/dialogs/generic/generic.dialog';
import { ServiceDialog } from 'src/app/dialogs/service/service.dialog';
import { DialogsReturnCode } from 'src/app/enums/dialogs/returnCode.enum';
import { HandlerManager } from 'src/app/managers/handler/handler.manager';
import { LoadingManager } from 'src/app/managers/loading/loading.manager';
import { PipeManager } from 'src/app/managers/pipe/pipe.manager';
import { SessionManager } from 'src/app/managers/session/session.manager';

@Component
({
  selector: 'service.management.page',
  templateUrl: './service.management.page.html',
  styleUrls: ['./service.management.page.scss']
})
export class ServiceManagementPage implements OnInit 
{
  orgSelect: OrganizationSelect
  @ViewChild('orgManager') set _orgSelect(orgSelect: OrganizationSelect){
    if (orgSelect){
      this.orgSelect = orgSelect
    }
  }
  site: Site
  @ViewChild('siteManager') set _siteSelect(siteSelect: SiteSelect){
    if (siteSelect){
      this.site = siteSelect.getSelectedValue()
      this.init()
    }
  }

  @ViewChild('serviceTable') serviceTable: CustomTableComponent

  serviceColumns: CustomColumn [] = [
    {
      isId   : true,
      label  : "id",
      name   : "id",
      display: ( val : any ) => false ,
    },
    {
      label: "name",
      name : "tables.service.labels.name"
    },
    {
      label: "counterName",
      name : "tables.service.labels.counterName",
      pipe : (counterName: any) => this._pipe.tables().is_not_null(counterName, "-"),
    },
    {
      label: "priority",
      name : "tables.service.labels.priority",
      pipe : (priority: any) => this._pipe.tables().is_not_null(priority, "-"),
    },
    {
      label: "active",
      name : "tables.service.labels.active",
      pipe : (active: any) => this._pipe.tables().is_active(active),
    }
  ]

  buttons: CustomButton[] = [
    {
      label : "disable_service",
      column: "tables.service.labels.action",
      name  : "tables.service.labels.enable_disable",
      action: async (item: any) => { 
        await this.changeStatus(item)
      }
    }
  ]

  constructor
  (
    private _handler: HandlerManager,
    private _loader : LoadingManager,
    private _session: SessionManager,
    private _dialog : MatDialog     ,
    private _pipe   : PipeManager   ,
  ) {}

  values   : ServiceMin[]
  siteId   : number
  serviceId: number

  ngOnInit(): void 
  {  }

  //----------------------------------------------------------------------------------------
  
  async init() 
  {
    if ( this.site ) 
    {
      this.values = await this.retriveValues( this.site.id );
    }
  }

  setSite( site: Site )
  {    
    this.site = site
    this.init()
  }

  //----------------------------------------------------------------------------------------
  
  create()
  {
    this.openDialog("create", null)
  }

  async update(item: any)
  {
    let service = await this.getDetail( item.id )
    this.openDialog( "update", service )
  }

  async changeStatus(item: any)
  {
    this.serviceId = item.id
    this.openDialog( "change-status", null )
  }

  //----------------------------------------------------------------------------------------

  async openDialog( action: string, service: ServiceDetail )
  {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus    = true;

    let dialog: any

    if( action && action != "change-status" )
    {
      let categories = await this.getCategory()

      dialogConfig.data = {
        siteId        : this.site.id,
        categories    : categories  ,
        service       : service
      }      
      dialog = this._dialog.open(ServiceDialog, dialogConfig);
    }
    else if( action )
    {
      dialog = this._dialog.open(GenericDialog, dialogConfig);
    }
    else return

    dialog.afterClosed().subscribe(async (data: any) =>
    {
      //Delete message and refresh table data
      if (data.code == DialogsReturnCode.OPERATION_ACCEPTED)
      {
        await this.changeServiceStatus()
        this.values = await this.retriveValues( this.site.id )
      }

      //Refresh table data
      if (data.code == DialogsReturnCode.SERVICE_OPERATION_ACCEPTED)
      {
        this.values = await this.retriveValues( this.site.id )
      }
    })
  }
  
  //----------------------------------------------------------------------------------------

  async retriveValues( siteId: number ) 
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect 

    this._loader.start()
    this.serviceTable.reloadData()

    let response = null

    response = await this._handler.service().getServiceMin((user as User).token, siteId)

    this._loader.stop()
    this.serviceTable.dataLoaded()

    if ( !response      ) return
    if ( !response.list ) return

    return response.list as ServiceMin[];
  }

  async getDetail( serviceId: number ) 
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect 

    this._loader.start()

    let response = null

    response = await this._handler.service().getDetail((user as User).token, this.site.id, serviceId)        
    this._loader.stop()

    if ( !response        ) return
    if ( !response.object ) return

    return response.object;
  }

  async getCategory()
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect 

    this._loader.start()

    let response = null

    response = await this._handler.service().getCategory((user as User).token)

    this._loader.stop()

    if ( !response      ) return
    if ( !response.list ) return

    return response.list as ServiceCategory[];
  }

  async changeServiceStatus() 
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect 

    this._loader.start()

    await this._handler.service().changeStatus((user as User).token, this.serviceId)

    this._loader.stop()
  }
}
